import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "wo-apostle-list"
};
const _hoisted_2 = {
  key: 0,
  class: "item-card-grid-view"
};
const _hoisted_3 = {
  class: "info-container"
};
const _hoisted_4 = {
  class: "main-text",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_5 = {
  class: "main-text",
  style: {
    "font-size": "0.75rem",
    "font-weight": "normal"
  }
};
const _hoisted_6 = {
  class: "second-text"
};
const _hoisted_7 = {
  key: 1,
  class: "empty-data-tips"
};
import { computed, onMounted, ref } from 'vue';
import { request } from '@/manager/net_manager';
import { ElImage } from 'element-plus';
import store from "@/store"; // refs

export default {
  __name: 'WOApostleList',

  setup(__props) {
    const dataArray = ref([]); // computed

    const worldOutlook = computed(() => store.state.world_outlook); // functions

    const getData = () => {
      let parameters = {};

      if (worldOutlook.value !== null) {
        parameters['world_outlook_id'] = worldOutlook.value.id;
        request('world_outlook/get_wo_apostles/', parameters, 'POST').then(response => {
          // console.log(JSON.stringify(response))
          if (response.code === 0) {
            dataArray.value = response.data;
          }
        });
      }
    }; // lifecycle


    onMounted(() => {
      getData();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [dataArray.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataArray.value, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item-card"
        }, [_createVNode(_unref(ElImage), {
          src: item.avatar,
          fit: "cover",
          draggable: "false"
        }, null, 8, ["src"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("text", _hoisted_4, _toDisplayString(item.name), 1), _createElementVNode("text", _hoisted_5, _toDisplayString(item.desc), 1), _createElementVNode("text", _hoisted_6, " 已完成演出 " + _toDisplayString(item.resumes_count) + " 场 ", 1)])]);
      }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[0] || (_cache[0] = [_createElementVNode("text", {
        style: {
          "display": "flex"
        }
      }, "未发现链接者数据", -1)]))]))]);
    };
  }

};